import * as React from "react";
import { AlertTriangle } from "lucide-react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Radio,
  Snackbar,
  TextField,
} from "@mui/material";
import { useFirstTheme, usePaymentLink } from "./page";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaymentIcon from "@mui/icons-material/Payment";
// import CvvInfo from "./cvvInfo";

import upiSvg from "../assets/upi.svg";
import phonepaySvg from "../assets/phonepaynew12.svg";
import paytmSvg from "../assets/Paytmnew12.svg";
import bhimlogoSvg from "../assets/bhimnew12.svg";
import gpaylogoSvg from "../assets/gpaynew12.svg";
import addmoreSvg from "../assets/addmore.svg";
import cardSvg from "../assets/card.svg";
import emptywalletSvg from "../assets/emptywallet.svg";
import bankiconSvg from "../assets/bankicon.svg";

import successupi from "../assets/upisuccess.svg";
import failedupi from "../assets/upifailed.svg";

//

import axixbankSvg from "../assets/axisbank.svg";
import hdfcbankSvg from "../assets/hdfcbank.svg";
import icicibankSvg from "../assets/icicibank.svg";
import kotakbankSvg from "../assets/kotakbank.svg";
import sbibankSvg from "../assets/sbibank.svg";
// import info from "../assets/information.svg";
import bandhanBankSvg from "../assets/bandhanbanks.svg";

import paylaterIcon from "../assets/paylater.svg";
import { SplitByNum, removeWhiteSpace } from "../utils/splitByNum";
import Popup from "../components/popup";
import { useFirstModule } from "../provider/invoiceProvider";
import { isMobile } from "react-device-detect";
import { initiateInvoiceTransaction } from "../services/initiateInvoiceTransaction";
import { isValidUpi } from "../utils/isValidUpi";
import { formatCardNumber } from "../utils/cardUtils";
// import LazyPayIcon from "../assets/LazyPay.svg";
// import simplIcon from "../assets/getsimplIcon.svg";

interface CountryType {
  code: string;
  label: string;
  img?: string;
}

// interface CardDataType {

//   txn_mode: "DC" | "CC";
//   card_number: string;
//   card_holder_name: string;
//   card_cvv: string;
//   card_expiry_date: string;
// }
interface CardDataType {
  invoice_id: string;
  cardNo: string;
  cardExpiry: string;
  cvv: string;
  cardHolderName: string;
  payMode: "cc" | "dc";
}

interface CardDataTypeError {
  txn_mode?: string;
  card_number?: string;
  card_holder_name?: string;
  card_cvv?: string;
  card_expiry_date?: string;
}

export default function PaymentType() {
  const [open, setOpen] = React.useState(false);
  const [openCard, setOpenCard] = React.useState(true);
  const [payLater, setPayLater] = React.useState(false);
  const [isNetBanking, setNetBanking] = React.useState(false);
  const { invoiceLink, updateTheme } = useFirstTheme();
  const { linkData, updatePaymentLink } = usePaymentLink();
  const [isAvailable, setAvailable] = React.useState(false);
  const { invoiceData, toggleSelected, isSelected } = useFirstModule();
  // const [showCvvInfo, setCvvInfo] = React.useState(false);
  const [upiId, setUpiId] = React.useState("");
  const [trigger, setTrigger] = React.useState(false);

  const [htmlContent, setHtmlContent] = React.useState<string>("");
  const [isPopupOpen, setIsPopupOpen] = React.useState<boolean>(false);
  // const [cardData, setCardData] = React.useState<CardDataType>({
  //   txn_mode: "DC",
  //   card_number: "",
  //   card_holder_name: "",
  //   card_cvv: "",
  //   card_expiry_date: "",
  // });
  const [cardData, setCardData] = React.useState<CardDataType>({
    invoice_id: invoiceData?.invoiceId || "",
    cardNo: "",
    cardExpiry: "",
    cvv: "",
    cardHolderName: "",
    payMode: "dc",
  });
  const [isVerified, setVerified] = React.useState<boolean | undefined>(
    undefined,
  );

  const [cardDataError, setCardDataError] = React.useState<CardDataTypeError>({
    txn_mode: "",
    card_number: "",
    card_holder_name: "",
    card_cvv: "",
    card_expiry_date: "",
  });
  const [selectedBank, setSelectedBank] = React.useState("");
  const [upiMessage, setUpiMessage] = React.useState({
    error: "",
    success: "",
    userName: "",
  });
  const [loading, setLoading] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "error" as "success" | "error" | "info" | "warning",
  });

  const [activeOption, setActiveOption] = React.useState([
    "UPI",
    "NET_BANKING",
    "CARD",
    // "PAY_LATER",
  ]);

  // React.useEffect(() => {}, []);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const handleUpiId = (e: any) => {
    setUpiId(e.target.value);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const showSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning" = "error",
  ) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const redirectToPaymentApp = async (selectedGateway: string) => {
    let dataLink = invoiceLink?.link;
    if (!trigger) {
      const data = await initiateInvoiceTransaction(invoiceData);
      // console.log(trigger, "-<><><>>>>>>----->");
      updateTheme({
        link: data?.link,
        order_id: data?.order_id,
      });

      dataLink = data?.link;
      setTrigger(true);
    }

    // console.log(dataLink, "------>");
    // toggleSelected();
    let paymentLink;
    // console.log(invoiceLink, "invoiceLink->");
    switch (selectedGateway) {
      case "gpay":
        // window.location.href = `googlepay://upi/transaction?pa=${encodeURIComponent(
        //   paymentLink
        // )}`;
        paymentLink = dataLink?.replace("upi://", "tez://upi/");
        updatePaymentLink({
          link: paymentLink,
          app: "gpay",
          upiId: "",
        });
        break;
      case "phonepe":
        // window.location.href = `phonepe://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "phonepe://");
        updatePaymentLink({
          link: paymentLink,
          app: "phonepe",
          upiId: "",
        });
        break;
      case "paytm":
        // window.location.href = `paytm://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "paytmmp://");
        updatePaymentLink({
          link: paymentLink,
          app: "paytm",
          upiId: "",
        });
        break;
      case "bhim":
        // window.location.href = `bhim://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "upi://pay?");
        updatePaymentLink({
          link: paymentLink,
          app: "bhim",
          upiId: "",
        });
        break;
      default:
        console.error("Unsupported payment gateway");
    }
    // console.log(paymentLink, selectedGateway, "paymentLink");
  };

  // React.useEffect(() => {
  //   setTrigger(!trigger);
  // }, [isSelected]);

  //    const redirectToPaymentApp = (selectedGateway: string) => {
  // console.log(selectedGateway,"wertyui");

  //    }

  const paymentMethods = [
    {
      icon: phonepaySvg,
      name: "PhonePe",
      link: "",
      appName: "phonepe",
    },
    {
      icon: paytmSvg,
      name: "Paytm",
      link: "",
      appName: "paytm",
    },
    {
      icon: bhimlogoSvg,
      name: "BHIM",
      link: "",
      appName: "bhim",
    },
    {
      icon: gpaylogoSvg,
      name: "Gpay",
      link: "",
      appName: "gpay",
    },
  ];

  const payLaterArray = [
    {
      name: "ICICI Pay later",
      icon: paylaterIcon,
      value: "",
    },
    {
      name: "Lazypay",
      icon: paylaterIcon,
      value: "",
    },
    {
      name: "Lazypay",
      icon: paylaterIcon,
      value: "",
    },
  ];

  const netBankingArray = [
    {
      name: "Axis Bank",
      icon: axixbankSvg,
      value: "",
    },
    {
      name: "HDFC Bank",
      icon: hdfcbankSvg,
      value: "",
    },
    {
      name: "ICICI Bank",
      icon: icicibankSvg,
      value: "",
    },
    {
      name: "Kotak Bank",
      icon: kotakbankSvg,
      value: "",
    },
    {
      name: "SBI Bank",
      icon: sbibankSvg,
      value: "",
    },
  ];

  const handleOpen = () => {
    setOpen(!open);
    updatePaymentLink({
      link: "",
      app: "",
      upiId: "",
    });
  };
  const handleCard = () => {
    setOpenCard(!openCard);
  };
  const handlePayLater = () => {
    setPayLater(!payLater);
  };

  const handleNetBanking = () => {
    setNetBanking(!isNetBanking);
  };

  // const validateCardData = (data: CardDataType) => {
  //   const ErrorObj: CardDataTypeError = {};
  //   let isValid = true;

  //   const checkNumber = /^\d+$/;
  //   const checkExpiry = /^(0[1-9]|1[0-2])\/\d{2}$/;
  //   const checkNameValidity = /^[A-Za-z\s]+$/;

  //   if (data?.card_number === "" && !checkNumber.test(data?.card_number)) {
  //     ErrorObj.card_number = "Kindly Enter a Valid Card Number";
  //     isValid = false;
  //   }
  //   // if (data?.amount === "" && !checkNumber.test(data?.amount)) {
  //   //   ErrorObj.amount = "Kindly Enter a Valid Payable Amount";
  //   //   isValid = false;
  //   // }

  //   if (data?.card_cvv === "" && !checkNumber.test(data?.card_cvv)) {
  //     ErrorObj.card_cvv = "Kindly Enter a Valid CVV";
  //     isValid = false;
  //   }

  //   if (
  //     data?.card_expiry_date === "" &&
  //     !checkExpiry.test(data?.card_expiry_date)
  //   ) {
  //     ErrorObj.card_expiry_date = "Kindly Enter a Valid Expiry Date";
  //     isValid = false;
  //   }

  //   if (
  //     data?.card_holder_name === "" &&
  //     !checkNameValidity.test(data?.card_holder_name)
  //   ) {
  //     ErrorObj.card_holder_name = "Kindly Enter a Valid Name";
  //     isValid = false;
  //   }

  //   setCardDataError({
  //     ...cardDataError,
  //     ...ErrorObj,
  //   });
  //   return isValid;
  // };

  const validateCardData = (data: any) => {
    const ErrorObj: any = {};
    let isValid = true;

    const checkNumber = /^\d+$/;
    const checkExpiry = /^(0[1-9]|1[0-2])\/\d{2}$/;
    const checkNameValidity = /^[A-Za-z\s]+$/;

    // CARD NUMBER
    if (!data?.cardNo || !checkNumber.test(data.cardNo)) {
      ErrorObj.cardNo = "Kindly Enter a Valid Card Number";
      isValid = false;
    }

    // CVV
    if (!data?.cvv || !checkNumber.test(data.cvv)) {
      ErrorObj.cvv = "Kindly Enter a Valid CVV";
      isValid = false;
    }

    // EXPIRY DATE
    if (!data?.cardExpiry || !checkExpiry.test(data.cardExpiry)) {
      ErrorObj.cardExpiry = "Kindly Enter a Valid Expiry Date (MM/YY)";
      isValid = false;
    }

    // CARD HOLDER NAME
    if (!data?.cardHolderName || !checkNameValidity.test(data.cardHolderName)) {
      ErrorObj.cardHolderName = "Kindly Enter a Valid Name";
      isValid = false;
    }

    // OPTIONAL: invoice_id check
    if (!data?.invoice_id) {
      ErrorObj.invoice_id = "Invoice ID is required";
      isValid = false;
    }

    setCardDataError((prev: any) => ({
      ...prev,
      ...ErrorObj,
    }));

    return isValid;
  };

  const netBankingType: readonly CountryType[] = [
    { code: "AXB", label: "Axis Bank ", img: axixbankSvg },
    {
      code: "BANB",
      label: "Bandhan Bank",
      img: bandhanBankSvg,
    },
    { code: "HDFCB", label: "HDFC Bank", img: hdfcbankSvg },
    {
      code: "ICICIB",
      label: "ICICI Bank",
      img: icicibankSvg,
    },
    {
      code: "SBOI",
      label: "State Bank of India",
      img: sbibankSvg,
    },
  ];

  // const fetchHtmlContent = async () => {
  //   if (validateCardData(cardData)) {
  //     openPopup();
  //     try {
  //       const response = await fetch(
  //         "https://backend.vaamozdevelop.xyz/VampayLiveApi/EasebuzzDebitPayment",
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Origin: "https://vaamoz.com",
  //           },
  //           body: JSON.stringify({
  //             ...cardData,
  //             amount: invoiceData?.payable_amount,
  //           }),
  //         },
  //       );
  //       const html = await response.text();
  //       setHtmlContent(html);
  //     } catch (error) {
  //       console.error("Error fetching HTML:", error);
  //     }
  //   }
  // };

  // const handle3DSecure = (data: any) => {
  //   const { acsURL, params } = data;

  //   // Create form dynamically
  //   const form = document.createElement("form");
  //   form.method = "POST";
  //   form.action = acsURL;

  //   // Hidden input for cReq
  //   const input = document.createElement("input");
  //   input.type = "hidden";
  //   input.name = "creq";
  //   input.value = params.cReq;

  //   form.appendChild(input);

  //   // Append form to body
  //   document.body.appendChild(form);

  //   // Auto submit
  //   form.submit();
  // };

  const handle3DSecure = (data: any) => {
    const { acsURL, cReq } = data.params;

    if (!acsURL || !cReq) {
      alert("Invalid 3DS data");
      return;
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = acsURL;

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "creq";
    input.value = cReq;

    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  };

  // const makeCardPayment = async () => {
  //   // ✅ Step 1: Validate before API call
  //   const isValid = validateCardData(cardData);

  //   if (!isValid) {
  //     alert("Validation failed");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       "https://backend.vaamozdevelop.xyz/VampayLiveApi/PgCardPayment",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(cardData),
  //       },
  //     );

  //     const res = await response.json();

  //     console.log("Payment Response:", res);

  //     // ✅ Step 2: Handle 3D Secure
  //     if (res?.status && res?.data?.type === "3D_SECURE") {
  //       handle3DSecure(res.data);
  //     } else {
  //       console.error("Payment failed or unexpected response");
  //     }
  //   } catch (error) {
  //     console.error("Payment Error:", error);
  //   }
  // };

  const makeCardPayment = async () => {
    const isValid = validateCardData(cardData);

    if (!isValid) {
      showSnackbar("Please fill all details correctly", "error");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(
        "https://backend.vaamozdevelop.xyz/VampayLiveApi/PgCardPayment",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cardData),
        },
      );

      const res = await response.json();

      if (res?.status) {
        //  this is second response

        if (res?.redirection_type === "Url_redirection") {
          const redirectUrl = res?.data?.redirectUrl;

          if (redirectUrl) {
            showSnackbar("Redirecting to payment gateway...", "info");

            // 🔥 hard redirect (best for payment flows)
            window.location.href = redirectUrl;
          } else {
            showSnackbar("Invalid redirect URL", "error");
          }

          return; // ⛔ stop further execution
        }

        if (res?.data?.type === "3D_SECURE") {
          showSnackbar("Redirecting to bank for OTP...", "info");
          handle3DSecure(res.data);
        } else {
          showSnackbar(res?.message || "Payment successful", "success");
        }
      } else {
        showSnackbar(res?.message || "Payment failed", "error");
      }
    } catch (error: any) {
      showSnackbar(
        error?.message || "Something went wrong. Please try again.",
        "error",
      );
      console.error("Payment Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCardChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    let updatedValue = value;

    switch (name) {
      case "cardNo":
        updatedValue = value.replace(/\D/g, "").slice(0, 16);
        break;

      case "cardHolderName":
        updatedValue = value.replace(/[^a-zA-Z\s]/g, "").toUpperCase();
        break;

      case "cardExpiry":
        const cleaned = value.replace(/\D/g, "").slice(0, 4);
        updatedValue =
          cleaned.length > 2
            ? `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`
            : cleaned;
        break;

      case "cvv":
        updatedValue = value.replace(/\D/g, "").slice(0, 4);
        break;

      default:
        break;
    }

    setCardData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  //! below is the original code for card data change

  // const handleCardChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   let { name, value } = e.target;

  //   if (name === "card_expiry_date") {
  //     // Remove all non-digits
  //     value = value.replace(/\D/g, "");

  //     // Add slash after 2 digits
  //     if (value.length >= 3) {
  //       value = value.slice(0, 2) + "/" + value.slice(2, 4);
  //     }
  //   }

  //   if (name === "card_number") {
  //     value = removeWhiteSpace(value);
  //     // Remove all non-digits
  //     value = value.replace(/\D/g, "");
  //   }
  //   setCardData({ ...cardData, [name]: value });
  // };

  const handleCardTypeChange = () => {
    const cardType = cardData?.payMode === "dc" ? "cc" : "dc";

    setCardData({ ...cardData, payMode: cardType });
  };

  // const verifyUpiID = async () => {
  //   const response = await fetch(
  //     "https://api.vampay.in/Merchent/ValidateVpaId",
  //     {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ vpa_id: upiId }),
  //     }
  //   );
  //   const data = await response.json();
  //   if (data.status) {
  //     setVerified(true);

  //     updatePaymentLink({
  //       link: "payViaUPI",
  //       app: "",
  //       upiId: upiId,
  //     });
  //     setUpiMessage({
  //       error: "",
  //       success: data.message,
  //       userName: data?.data?.name,
  //     });
  //   } else {
  //     setUpiMessage({
  //       error: data.message,
  //       success: "",
  //       userName: "",
  //     });
  //   }
  // };

  const verifyUpiID = async () => {
    const response = await fetch(
      // "https://backend.vaamozdevelop.xyz/VampayLiveApi/Collect",
      "https://backend.vaamozdevelop.xyz/VampayLiveApi/PgInitCollect",
      {
        method: "POST",
        headers: {
          Token: "a7767604ddef15c1937671f1e6d5e29a",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // merchant_id: "OCC36873",
          // email_id: "rahul@vaamoz.com",
          // mobile_no: "9734570474",
          // amount: "1",
          // webhook_url: "test.com/test",
          // vpa: "9734570474@ybl",
          invoice_id: invoiceData?.invoiceId,
          vpa: upiId,
        }),
      },
    );
    const data = await response.json();
    if (data.status) {
      setVerified(true);

      //      {
      //   "order_id": "20260119074948661c4b",
      //   "txn_id": null,
      //   "is_redirect": true,
      //   "redirectURI": "https:\/\/jiopay.co.in\/pg\/api\/v2\/authRedirect?tranCtx=R93dd3d36-2d44-4726-8faf-34250a359cd8"
      // }

      if (data?.data?.is_redirect) {
        window.location.href = data.data.redirectURI;
      }
    } else {
      setUpiMessage({
        error: data.message,
        success: "",
        userName: "",
      });
    }
  };

  const handleSelectionChange = (event: React.SyntheticEvent, value: any) => {
    value?.code && setSelectedBank(value?.code);
  };

  const handleNetBankingSubmit = async () => {
    openPopup();
    try {
      const response = await fetch(
        "https://backend.vaamozdevelop.xyz/VampayLiveApi/EasebuzzNetBanking",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Origin: "https://vaamoz.com",
          },
          body: JSON.stringify({
            amount: invoiceData?.payable_amount,
            bank: selectedBank,
          }),
        },
      );
      const html = await response.text();

      setHtmlContent(html);
    } catch (error) {
      console.error("Error fetching HTML:", error);
    }
  };

  return (
    <div className="my-4 shadow-lg rounded-xl">
      <List
        sx={{
          width: "100%",
          minWidth: 275,
          bgcolor: "background.paper",
          borderRadius: 4,
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        <ListItemButton onClick={handleCard}>
          <ListItemIcon className="">
            <img src={cardSvg} alt="logo" height={20} width={20} className="" />
          </ListItemIcon>
          <ListItemText primary="CARD" />
          {openCard ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        {activeOption.includes("CARD") ? (
          <Collapse
            in={openCard}
            // in={true}
            timeout="auto"
            unmountOnExit
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <div className="flex gap-3 flex-wrap p-4 bg-[#F5F5F5]">
              <Button
                variant="outlined"
                endIcon={<ArrowDropDownIcon />}
                startIcon={
                  cardData?.payMode === "dc" ? (
                    <PaymentIcon />
                  ) : (
                    <CreditCardIcon />
                  )
                }
                fullWidth
                onClick={handleCardTypeChange}
              >
                {cardData?.payMode === "dc" ? "Debit Card" : "Credit Card"}
              </Button>
              <div
                className={`flex items-center justify-between w-full p-2 border rounded-md ${
                  cardDataError?.card_number ? "border-red-500" : ""
                }`}
              >
                <input
                  // type="number"
                  // name="card_number"
                  name="cardNo"
                  placeholder="Card Number"
                  className={`w-full bg-transparent outline-none `}
                  value={formatCardNumber(cardData?.cardNo)}
                  // value={cardData?.card_number}
                  onChange={handleCardChange}
                />
              </div>
              <p className="text-red-600">{cardDataError?.card_number}</p>
              <input
                name="cardHolderName"
                placeholder="Name on card"
                className={`w-full p-2 bg-transparent border rounded-md outline-none ${
                  cardDataError?.card_holder_name ? "border-red-500" : ""
                }`}
                value={cardData?.cardHolderName}
                onChange={handleCardChange}
              />
              <p className="text-red-600">{cardDataError?.card_holder_name}</p>
              <div className="flex w-full gap-3">
                <input
                  name="cardExpiry"
                  placeholder="Valid Thru (MM/YY)"
                  className={`w-2/3 p-2 bg-transparent border rounded-md outline-none ${
                    cardDataError?.card_expiry_date ? "border-red-500" : ""
                  }`}
                  value={cardData?.cardExpiry}
                  onChange={handleCardChange}
                />
                <div
                  className={`flex items-center justify-between w-1/3 p-2 border rounded-md ${
                    cardDataError?.card_cvv ? "border border-red-500" : ""
                  }`}
                >
                  <input
                    type="number"
                    name="cvv"
                    placeholder="CVV"
                    className={`overflow-x-hidden w-full bg-transparent rounded-md outline-none `}
                    value={cardData?.cvv}
                    onChange={handleCardChange}
                  />
                </div>
              </div>
              <p className="text-red-600">{cardDataError?.card_cvv}</p>
              <p className="text-red-600">{cardDataError?.card_expiry_date}</p>
              <Button
                variant="contained"
                // onClick={fetchHtmlContent}
                onClick={makeCardPayment}
                fullWidth
                disabled={invoiceData?.payable_amount === "" || loading}
              >
                {loading ? "Processing..." : "Pay Now"}
              </Button>
            </div>
          </Collapse>
        ) : (
          <Collapse
            in={openCard}
            timeout="auto"
            unmountOnExit
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <div className="flex gap-3 flex-wrap p-4 text-center bg-[#F5F5F5]">
              <p className="font-medium text-[14px] text-[#ABABAB]">
                This functionality is currently unavailable for this Merchant
              </p>
            </div>
          </Collapse>
        )}

        <ListItemButton onClick={handleOpen}>
          <ListItemIcon className="">
            <img src={upiSvg} alt="logo" height={20} width={20} className="" />
          </ListItemIcon>
          <ListItemText primary="UPI" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        {activeOption.includes("UPI") ? (
          <Collapse
            in={open}
            timeout="auto"
            unmountOnExit
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <div className="flex gap-3 justify-between flex-wrap p-4 bg-[#F5F5F5]">
              {isMobile &&
                paymentMethods.map((item, index) => (
                  <button
                    onClick={() => {
                      redirectToPaymentApp(item.appName);

                      // console.log("gatewayClicked", linkData, item.appName);
                    }}
                    key={index}
                    className={`p-1 w-1/5 flex flex-col justify-start items-center gap-2 ${
                      linkData?.app === item.appName
                        ? "border border-purple-500 rounded-lg bg-white"
                        : null
                    }`}
                  >
                    <img src={item.icon} alt="." height={40} width={40} />
                    <p
                      className={`text-wrap ${
                        linkData?.app === item.appName
                          ? "text-[14px]"
                          : "text-[#ABABAB]"
                      }`}
                    >
                      {item.name}
                    </p>
                  </button>
                ))}

              <div className="flex w-full flex-col gap-3 justify-between flex-wrap  bg-[#F5F5F5]">
                <div className="flex items-center justify-between w-full gap-3">
                  <div className="flex items-center justify-between w-full p-2 border rounded-md ">
                    <input
                      placeholder="Enter UPI"
                      className="w-full bg-transparent outline-none"
                      value={upiId}
                      onChange={handleUpiId}
                    />
                    {isVerified === true ? (
                      <img src={successupi} alt="upi status" className="px-2" />
                    ) : isVerified === false ? (
                      <img src={failedupi} alt="upi status" className="px-2" />
                    ) : null}
                  </div>
                  <Button
                    style={{
                      color: "white",
                      background: "#6769FE",
                      boxShadow: "none",
                    }}
                    size="large"
                    variant="contained"
                    className="text-nowrap"
                    onClick={() =>
                      isValidUpi(upiId) ? verifyUpiID() : alert("invalid UPI")
                    }
                    disabled={isVerified}
                  >
                    Verify
                  </Button>
                </div>
                <div className="flex items-center justify-between ">
                  {upiMessage.error ? (
                    <p className="text-red-600">{upiMessage.error}</p>
                  ) : (
                    <p className="text-green-600">{upiMessage.userName}</p>
                  )}
                  <p className="text-green-600">{upiMessage.success}</p>
                </div>
              </div>
            </div>
          </Collapse>
        ) : (
          <Collapse
            in={open}
            timeout="auto"
            unmountOnExit
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <div className="p-8">
              <div className="flex items-center justify-center gap-2 rounded-lg border border-amber-100 bg-amber-50/50 px-4 py-2.5 shadow-sm max-w-xl mx-auto">
                <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500" />
                <p className="text-sm font-medium text-amber-800 tracking-tight">
                  This functionality is currently unavailable for this merchant.
                </p>
              </div>
            </div>
          </Collapse>
        )}

        <ListItemButton onClick={handleNetBanking}>
          <ListItemIcon className="">
            <img
              src={bankiconSvg}
              alt="logo"
              height={20}
              width={20}
              className=""
            />
          </ListItemIcon>
          <ListItemText primary="NET BANKING" />
          {isNetBanking ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        {activeOption.includes("NET_BANKING") ? (
          <Collapse in={isNetBanking} timeout="auto" unmountOnExit>
            <div className="bg-[#F5F5F5] flex flex-col px-2 p-2 gap-4">
              <Autocomplete
                fullWidth
                id="country-select-demo"
                options={netBankingType}
                autoHighlight
                getOptionLabel={(option) => option.label}
                onChange={handleSelectionChange}
                renderOption={(props, option) => {
                  const { ...optionProps } = props;
                  return (
                    <Box
                      // key={key}
                      component="li"
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...optionProps}
                    >
                      <img loading="lazy" width="20" src={option?.img} alt="" />
                      {option.label}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Choose a Bank"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                )}
              />
              <Button
                variant="contained"
                onClick={handleNetBankingSubmit}
                disabled={
                  !(
                    invoiceData?.payable_amount !== "" &&
                    selectedBank !== "" &&
                    Number(invoiceData?.payable_amount) > 0
                  )
                }
              >
                Submit
              </Button>
            </div>
          </Collapse>
        ) : (
          <Collapse in={isNetBanking} timeout="auto" unmountOnExit>
            <div className="p-8">
              <div className="flex items-center justify-center gap-2 rounded-lg border border-amber-100 bg-amber-50/50 px-4 py-2.5 shadow-sm max-w-xl mx-auto">
                <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500" />
                <p className="text-sm font-medium text-amber-800 tracking-tight">
                  This functionality is currently unavailable for this merchant.
                </p>
              </div>
            </div>
          </Collapse>
        )}

        {/* <ListItemButton onClick={handlePayLater}>
          <ListItemIcon className="">
            <img
              src={emptywalletSvg}
              alt="logo"
              height={20}
              width={20}
              className=""
            />
          </ListItemIcon>
          <ListItemText primary="PAY LATER" />
          {payLater ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        {isAvailable ? (
          <Collapse in={payLater} timeout="auto" unmountOnExit>
            <div className="bg-[#F5F5F5] flex flex-col px-2">
              {payLaterArray.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 border-b border-dashed"
                >
                  <div className="flex items-center gap-4">
                    <img src={item.icon} alt="." height={40} width={40} />
                    <p>{item.name}</p>
                  </div>
                  <div>
                    <Radio
                      checked={false}
                      // onChange={handleChange}
                      value="b"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "B" }}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 25,
                          background: "white",
                          borderRadius: 10,
                        },
                        margin: 0,
                        padding: 0,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </Collapse>
        ) : (
          <Collapse in={payLater} timeout="auto" unmountOnExit>
            <div className="flex gap-3 flex-wrap p-4 text-center bg-[#F5F5F5]">
              <p className=" text-[#ABABAB] font-medium text-[14px]">
                This functionality is currently unavailable for this trader
              </p>
            </div>
          </Collapse>
        )} */}
      </List>
      {/* {showCvvInfo && ( */}
      {/* <CvvInfo
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClick={handleClick}
        handleClose={handleClose}
      /> */}
      {/* )} */}
      <Popup
        htmlContent={htmlContent}
        onClose={closePopup}
        isOpen={isPopupOpen}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

// const Unavailable = (openProp: boolean) => {
//   return (
//     <Collapse
//       in={openProp}
//       timeout="auto"
//       unmountOnExit
//       sx={{ display: "flex", flexDirection: "row" }}
//     >
//       <div className="flex gap-3 flex-wrap p-4 text-center bg-[#F5F5F5]">
//         <p className="font-medium text-[14px] text-[#ABABAB]">
//           This functionality is currently unavailable for this Merchant
//         </p>
//       </div>
//     </Collapse>
//   );
// };
